import React from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import { ComposerEmptyState, ComposerEyebrow, ComposerPanel, ComposerPanelHeader, ComposerPanelTitle } from './composerWorkspace';

const Description = styled.p`
    max-width: 220px;
    margin: 0;
`;

const CustomizableAreasEditor: React.FC = () => {
    return (
        <ComposerPanel>
            <ComposerPanelHeader>
                <ComposerPanelTitle>
                    <ComposerEyebrow>{T._('Areas', 'Admin')}</ComposerEyebrow>
                </ComposerPanelTitle>
            </ComposerPanelHeader>
            <ComposerEmptyState>
                <Description>{T._('Customizable areas will be managed from this section. No area editor is connected yet.', 'Admin')}</Description>
            </ComposerEmptyState>
        </ComposerPanel>
    );
};

export default CustomizableAreasEditor;
